import { formatDate } from "../../../components/common/Converter";
import LogoHeader from "../../../components/common/LogoHeader";

export default function PrintDentalConsultation({ object }) {
  // console.log("OBJECT: ", object);

  const Header = () => (
    <div style={{ textAlign: "center", fontWeight: "bold", marginTop: "5px" }}>
      <h2
        style={{
          backgroundColor: "green",
          padding: "10px",
          color: "black",
          margin: "0",
        }}
      >
        Dental Consultation Form
      </h2>
    </div>
  );

  const Section = ({ title, fields, type }) => (
    <div>
      {/* <h4
        style={{
          backgroundColor: "#4CAF50",
          color: "black",
          padding: "5px 10px",
          margin: "0",
        }}
      >
        {title}
      </h4> */}
      <table
        style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}
      >
        <tbody>
          {fields.map((field) => {
            const empName = `${object?.employee?.Firstname || ""} ${
              object?.employee?.Middlename || ""
            } ${object?.employee?.surname || ""}`.trim();

            let fieldValue = object[field.name];

            if (fieldValue === "OTHERS" && field.name === "dentist") {
              fieldValue = object?.otherDentist;
            }
            if (fieldValue === "OTHERS" && field.name === "nurseInCharge") {
              fieldValue = object?.otherNurse;
            }

            if (Array.isArray(fieldValue)) {
              fieldValue =
                fieldValue.length > 0
                  ? fieldValue.map((item, index) => (
                      <span key={index}>
                        {item}
                        <br />
                      </span>
                    ))
                  : "____________________";
            } else {
              fieldValue = fieldValue || "____________________";
            }

            return (
              <tr key={field.name} style={{ borderBottom: "1px solid #ddd" }}>
                <td
                  style={{
                    fontWeight: "bold",
                    width: "30%",
                    padding: "8px",
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  {field.label}
                </td>
                <td style={{ width: "70%", padding: "8px" }}>
                  {field.type === "employee"
                    ? empName
                    : field.type === "date"
                    ? formatDate(fieldValue)
                    : field.type === "department"
                    ? object?.employee?.unit
                    : fieldValue}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  // const Drugs = ({ title, data }) => (
  //   <div>
  //     <h4
  //       style={{
  //         backgroundColor: "#4CAF50",
  //         color: "black",
  //         padding: "5px 10px",
  //         margin: "0",
  //       }}
  //     >
  //       {title}
  //     </h4>
  //     <table
  //       style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}
  //     >
  //       <thead>
  //         <tr
  //           style={{
  //             backgroundColor: "#f5f5f5",
  //             fontWeight: "bold",
  //             borderBottom: "1px solid #ddd",
  //           }}
  //         >
  //           <th
  //             style={{
  //               padding: "8px",
  //               width: "50%",
  //               textAlign: "start",
  //               borderBottom: "1px solid #ddd",
  //             }}
  //           >
  //             (List of Drugs available in MDS)
  //           </th>
  //           <th
  //             style={{
  //               padding: "8px",
  //               width: "50%",
  //               textAlign: "start",
  //               borderBottom: "1px solid #ddd",
  //             }}
  //           >
  //             Dosage and Frequency
  //           </th>
  //         </tr>
  //       </thead>
  //       <tbody>
  //         {Array.isArray(data) && data.length > 0 ? (
  //           data.map((entry, index) => (
  //             <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
  //               <td style={{ padding: "8px" }}>
  //                 {entry[0] || "____________________"}
  //               </td>
  //               <td style={{ padding: "8px" }}>
  //                 {entry[1] || "____________________"}
  //               </td>
  //             </tr>
  //           ))
  //         ) : (
  //           <tr>
  //             <td colSpan="3" style={{ textAlign: "center", padding: "8px" }}>
  //               No records available
  //             </td>
  //           </tr>
  //         )}
  //       </tbody>
  //     </table>
  //   </div>
  // );

  const SectionMedication = ({ title, data }) => (
    <div>
      <h4
        style={{
          backgroundColor: "#4CAF50",
          color: "black",
          padding: "5px 10px",
          margin: "0",
        }}
      >
        {title}
      </h4>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr
            style={{
              backgroundColor: "#f5f5f5",
              fontWeight: "bold",
              textAlign: "left",
            }}
          >
            <th style={{ padding: "8px", width: "30%" }}>Drugs</th>
            <th style={{ padding: "8px", width: "30%" }}>
              Dosage and Frequency
            </th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(data) && data.length > 0 ? (
            data.map((entry, index) => (
              <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "8px" }}>
                  {entry[0] || "____________________"}
                </td>
                <td style={{ padding: "8px" }}>
                  {entry[1] || "____________________"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: "center", padding: "8px" }}>
                No medication records available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div
      style={{
        width: "95%",
        padding: 0,
        margin: "auto",
        fontFamily: "Arial, sans-serif",
        fontSize: "14px",
        border: "1px solid #ddd",
      }}
    >
      <LogoHeader
        logoSrc={"/BIR.png"}
        altText="Print Logo"
        mainLabel="Republic Of the Philippines"
        subLabel="BUREAU OF IMMIGRATION"
        description="Patriotism * Integrity * Professionalism"
        rightLogoSrc={"/Bagong-Pilipinas-Logo.png"}
      />

      {Header()}

      <Section
        // title="Section I. Patient Information"
        fields={[
          { name: "fullName", label: "Full Name", type: "employee" },
          // { name: "department", label: "Department", type: "department" },
          { name: "dateOfVisit", label: "Date Of Visit", type: "date" },
          { name: "timeOfVisit", label: "Time Of Visit" },
          { name: "dentist", label: "Dentist" },
          { name: "nurseInCharge", label: "Nurse In-charge" },
          { name: "chiefComplaint", label: "Chief Complaint" },
          { name: "vitalSigns", label: "Vital Signs" },
          { name: "diagnosis", label: "Diagnosis" },
          { name: "treatments", label: "Treatments" },
          { name: "remarks", label: "Remarks" },
        ]}
      />

      {Array.isArray(object?.drugs) && object?.drugs.length > 0 ? (
        <SectionMedication title="Drugs/Treatments" data={object.drugs} />
      ) : null}
    </div>
  );
}
